import { render } from "./CourseExamDetails.vue?vue&type=template&id=11f1fe6c"
import script from "./CourseExamDetails.vue?vue&type=script&lang=js"
export * from "./CourseExamDetails.vue?vue&type=script&lang=js"

import "./CourseExamDetails.vue?vue&type=style&index=0&id=11f1fe6c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__